if (!customElements.get('text-carousel-component')) {
  class TextCarouselComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section`);
      this.slides = this.querySelectorAll('.swiper-slide');
      
      if (this.slides.length <= 1) {
        return;
      }

      this.prevButton = this.querySelector('.swiper-button-prev');
      this.nextButton = this.querySelector('.swiper-button-next');

      this.sliderInstance = false;

      this.initSlider();
      
      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId !== this.sectionId) return;
          const target = e.detail.target;
          const index = Number(target.dataset.index);
          if (this.sliderInstance && typeof this.sliderInstance.slider !== 'undefined') {
            this.sliderInstance.slider.slideToLoop(index);
          }
        });
      }
    }

    initSlider() {
      const sliderOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: this.slides.length > 1,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        pagination: false,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        speed: 500,
        autoplay: false,
        threshold: 2,
      };

      if (typeof window.FoxTheme !== 'undefined' && typeof window.FoxTheme.Carousel !== 'undefined') {
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions, [
          window.FoxTheme.Swiper.EffectFade,
        ]);
        this.sliderInstance.init();

        const focusableElements = window.FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      } else {
        console.warn('FoxTheme.Carousel not available');
      }
    }

    disconnectedCallback() {
      if (this.sliderInstance && typeof this.sliderInstance.slider !== 'undefined') {
        this.sliderInstance.slider.destroy(true, true);
      }
    }
  }

  customElements.define('text-carousel-component', TextCarouselComponent);
}
